export const BASE_URL = process.env.REACT_APP_ADMIN_API_URL;
export const IMAGE_URL = process.env.REACT_APP_ADMIN_UPLOADS;
